import React from "react";
import { observer } from "mobx-react-lite";
import { Box, Typography, IconButton } from "@material-ui/core";
import SystemUpdateTwoToneIcon from "@material-ui/icons/SystemUpdateTwoTone";
import { ProgrammeUpdatesViewModel } from "./ProgrammeUpdatesViewModel";
import styled from "styled-components";
import { Attachment } from "./ProgrammeUpdatesView";
import { isEvidenceAnImage } from "Utils/Utils";

interface Props {
    viewModel: ProgrammeUpdatesViewModel;
    openEvidenceModal: (attachment: Attachment) => void;
}

const Docs = styled(Box)`
    h5,
    h4 {
        font: normal normal normal 14px/40px Open Sans;
        letter-spacing: -0.28px;
        color: #191919;
        cursor: pointer;
    }
`;

const sectionConfigs = [
    {
        key: "buildingControlSiteVisit",
        label: "Building control site visit",
        getFiles: (vm: ProgrammeUpdatesViewModel) => vm.buildingControlSiteVisitAttachments,
    },
    {
        key: "cleanlinessReport",
        label: "Cleanliness report",
        getFiles: (vm: ProgrammeUpdatesViewModel) => vm.cleanlinessReportAttachments,
    },
    {
        key: "otherProgrammeNotes",
        label: "Site manager general notes",
        getFiles: (vm: ProgrammeUpdatesViewModel) => vm.otherProgrammeNotesAttachments,
    },
    {
        key: "potentialProgrammeDelays",
        label: "Potential programme delays",
        getFiles: (vm: ProgrammeUpdatesViewModel) => vm.potentialProgrammeDelaysAttachments,
    },
    {
        key: "outstandingDesignInformation",
        label: "Outstanding design information",
        getFiles: (vm: ProgrammeUpdatesViewModel) => vm.outstandingDesignInformationAttachments,
    },
    {
        key: "materialStorage",
        label: "Material storage",
        getFiles: (vm: ProgrammeUpdatesViewModel) => vm.materialStorageAttachments,
    },
    {
        key: "labourShortage",
        label: "Labour shortage",
        getFiles: (vm: ProgrammeUpdatesViewModel) => vm.labourShortageAttachments,
    },
];

export const ProgrammeUpdatesAttachmentsListView: React.FC<Props> = observer(({ viewModel, openEvidenceModal }) => {
    return (
        <Docs mt={4}>
            {sectionConfigs.map((section) => {
                const rawFiles = section.getFiles(viewModel) || [];
                const files = Array.prototype.slice.call(rawFiles).filter((file: any) => file && !file.isDeleted);
                if (!files.length) return null;
                return (
                    <Box key={section.key} mb={2}>
                        <Typography className={"title"} variant={"h5"}>
                            <strong>{section.label}</strong>
                        </Typography>
                        <Box className="uploadedFile">
                            {files.map((file: any, idx: number) => (
                                <Box key={file.id || idx} className="uploadedFile-box" display="flex" alignItems="center" mb={1}>
                                    <Box className="uploadedFile-heading" display="flex" alignItems="center">
                                        <IconButton onClick={() => viewModel.DownloadFile(file.photoURL, file.fileName)}>
                                            <SystemUpdateTwoToneIcon />
                                        </IconButton>
                                        <Typography variant="body2" style={{ marginLeft: 8 }}>
                                            {file.photoURL && file.photoURL !== "" && isEvidenceAnImage(file.photoURL) && (
                                                <div className="pdf-link" onClick={() => openEvidenceModal({ id: file.id, name: file.fileName, url: file.photoURL })}>
                                                    {file.fileName}
                                                </div>
                                            )}
                                            {file.photoURLInline && file.photoURLInline !== "" && !isEvidenceAnImage(file.photoURLInline) && (
                                                <div className="pdf-link" onClick={() => viewModel.OpenFile(file.photoURLInline)}>
                                                    {file.fileName}
                                                </div>
                                            )}
                                        </Typography>
                                    </Box>
                                </Box>
                            ))}
                        </Box>
                    </Box>
                );
            })}
        </Docs>
    );
});
